import React, { useRef } from 'react';
import { Link, useNavigate } from "react-router-dom";
import ScrollablePhone from './ScrollablePhone';
import { NAMES_CONSTANTS } from '../../../constants';

const SenseiSectionEquityAndMailboxMoney = (props) => {

    const navigate = useNavigate();
    
    let userAccessToken = localStorage.getItem(NAMES_CONSTANTS.USER_ACCESS_TOKEN);
    console.debug('SenseiSectionEquityAndMailboxMoney: userAccessToken = ', userAccessToken);

    /*
    //let phoneScrollerDiv = React.createRef();
    let phoneScrollerDiv = useRef(null);
    let phoneScrollerDivScrollTop = 0;

    //const scrollEvent = (event) => { console.log(event); }
    //const scrollEvent = (event) => { console.debug('scrollEvent()'); }
    const scrollEvent = (event) => {
        console.debug('scrollEvent()', event);
        console.debug(`phoneScrollerDiv.current = ${ phoneScrollerDiv.current }`);
        //phoneScrollerDiv.current.scrollTo(0, 10);
        phoneScrollerDiv.current.scrollTop = phoneScrollerDivScrollTop++;
        console.debug(`phoneScrollerDiv.current.scrollTop = ${ phoneScrollerDiv.current.scrollTop }`);
    }
    //const scrollEvent = (event) => { console.log(event); }
    //const clickElement = (event) => { console.log(event); }
    const clickElement = (event) => { console.debug('clickElement()'); }
    const handleScroll = (event) => {
        console.debug('User scrolled!');
    };
    */

    return (
        <section
            className = 'sensei sensei-dark'
            style = {{
                //  backgroundImage: 'url(images/backgrounds/what-is-realsplit-background-275x183.jpg)'
                //backgroundImage: 'url(../../../assets/images/Sensei-Labs/WEBoffice-building-2023-11-27-05-34-41-utc.jpg)'
                //backgroundImage: 'url(images/Sensei-Labs/WEBoffice-building-2023-11-27-05-34-41-utc.jpg)'
                //, backgroundPosition: 'left 0px bottom -100px'
                //, backgroundPosition: 'center center'
                //, backgroundRepeat: 'no-repeat'
                //, backgroundSize: 'cover'
                //backgroundColor: '#233F79'
                //, maxWidth: 'var(--site-width)'
                //, maxWidth: '1500px'
                //, margin: 'auto'
                //paddingTop: '80px'
            }}
            >

            <div
                //id = 'what-is-realsplit-container'
                //className = 'container'
                //className = 'flex-container max-width'
                className = 'site-max-width'
                style = {{
                    //maxWidth: 'var(--site-width)'
                    //maxWidth: '1350px'
                    //, flexWrap: 'wrap'
                    margin: 'auto'
                    //, marginLeft: '0'
                    //, textAlign: 'left'
                    //, width: '1500px'
                    //,  backgroundImage: 'url(images/backgrounds/what-is-realsplit-background.jpg)'
                    //, backgroundPosition: 'center'
                    //, backgroundRepeat: 'no-repeat'
                    //, backgroundImage: 'url(images/backgrounds/what-is-realsplit-background-275x183.jpg), url(images/backgrounds/what-is-realsplit-background-striped.jpg)'
                    //, backgroundImage: 'url(images/deals/Hillcrest/Hillcrest-pool.png), url(images/backgrounds/what-is-realsplit-background-striped.jpg)'
                    //, backgroundImage: 'url(images/properties/Majestic-Hotel/Majestic-Hotel-Exterior.jpg), url(images/backgrounds/what-is-realsplit-background-striped.jpg)'
                    //, backgroundImage: 'url(/assets/images/Sensei-Labs/WEBoffice-building-2023-11-27-05-34-41-utc.jpg)'
                    //, backgroundPosition: 'left 0px bottom 100px, right 150px bottom 0px'
                    //, backgroundRepeat: 'no-repeat, no-repeat'
                    //, backgroundSize: '650px, 400px'
                    //, paddingBottom: '250px'
                }}
                >

                <div
                    //className = 'table'
                    style = {{
                        //  margin: 'auto'
                        //, marginLeft: '0'
                        //, textAlign: 'left'
                        //maxWidth: '1300px'
                        width: '100%'
                        , display: 'flex'
                        , flexDirection: 'row'
                        , flexWrap: 'wrap'
                        //, justifyContent: 'space-between'
                        //, justifyContent: 'space-around'
                        , justifyContent: 'space-evenly'
                        //, flex: '1 1 auto'
                        , margin: 'auto'
                        , textAlign: 'center'
                        //, padding: '50px 0px'
                        //, paddingBottom: '50px'
                        //, paddingTop: '50px'
                        //, paddingLeft: '20px'
                    }}>

                    <div
                        style = {{
                            //  paddingRight: '30px'
                            //, paddingBottom: '50px'
                            //, paddingTop: '50px'
                            //padding: '50px 30px 50px 20px'
                            padding: '50px 0px'
                        }}
                        >

                        <h2
                            //className = { styles.sectionTitle }
                            className = 'baskervville-regular'
                            style = {{
                                //padding: '50px 0px 50px 0px'
                                //textAlign: 'center'
                                textAlign: 'left'
                                /*
                                //display: 'inline'
                                //, margin: '0'
                                , padding: '20px 0px 30px 0px'
                                , color: 'var(--color-gray-800, #343A40)'
                                //, textAlign: 'center'
                                , fontFamily: 'Roboto Serif'
                                , fontStyle: 'italic'
                                , fontWeight: '500'
                                , lineHeight: '120%'
                                //, marginRight: '50px'
                                */
                                //, fontSize: '65px'
                                //, fontWeight: '550'
                                //, lineHeight: '60px'
                                , maxWidth: '650px'
                            }}
                            >
                            {/*
                            Equity & Mailbox Money <span style={{ whiteSpace: 'nowrap' }}>built from Decades of Experience.</span>
                            Equity & Mailbox Money &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; built from Decades of Experience.
                            Equity & Mailbox Money built from Decades of Experience.
                            */}
                            Equity & Mailbox Money <span className='heading-line2'>built from Decades of Experience.</span>
                        </h2>

                        <p
                            style = {{
                            //    marginBottom: '30px'
                            //    , marginTop: '10px'
                                //fontFamily: '"Baskervville", serif'
                                textAlign: 'left'
                                //, fontSize: '30px'
                                , maxWidth: '850px'
                            }}
                            >
                            RealSplit™ was founded to allow users access to industry-leading diligence, construction, asset management, and support.
                            Invest into an income producing property today and experience the best possible asset class to own.

                            {/*
                            <div
                                to="/search/all"
                                target = "_blank"
                                style = {{
                                    padding: "30px 0px 0px 0px"
                                    , textAlign: 'center'
                                    , margin: 'auto'
                                    , marginLeft: '-20px'
                                }}
                                >
                                <Link
                                    to = "/search/all"
                                    target = "_blank"
                                    >
                                <button
                                    type = 'button'
                                    //className = 'theme-success large'
                                    className = 'theme-sensei'
                                    >Create Account</button>
                                </Link>
                            </div>
                            */}
                        </p>

                        {/*
                        */}
                        <p
                            style={{
                                padding: "30px 0px 0px 0px"
                                , textAlign: 'left'
                            }}>

                            {/*
                            <Link to="/search/all" target="_blank">
                            */}
                                <button
                                    type = 'button'
                                    //className = 'theme-success large'
                                    className = 'theme-sensei'
                                    onClick = { (event) => {
                                        if (!userAccessToken) {
                                            props.loginRegisterFunctions.clickRegister(event);
                                            return;
                                        } else {
                                            //window.open('https://realsplit.deal.tribexa.com/deal/create-investment', '_blank').focus();
                                            navigate('/search/all')
                                        }
                                    }}
                                    >Invest Now</button>
                            {/*
                            </Link>
                            */}
                        </p>

                    </div>

                    <div
                        style = {{
                            paddingBottom: '50px'
                            , paddingTop: '50px'
                        }}
                        >
                        {/*
                        <ScrollableTable />
                        */}
                        <ScrollablePhone />
                    </div>
                    

                </div>
            </div>
        </section>
    );
}

export default SenseiSectionEquityAndMailboxMoney;
